/* eslint-disable max-len */
import { FC, useCallback, useEffect, useState } from 'react';

import { cn } from 'utils/helpers';
import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { Button } from 'ui/components/common';
import { useParams } from 'react-router-dom';
import { useCreateSessionContext } from 'modules/account/settings/hooks';
import { isEmpty } from 'lodash';

import Group22 from '../assets/Group 22.png';
import { useGetAccountCard } from '../hooks';

const CardPreview: FC = () => {
  const { id } = useParams();
  const { data: accountCard, isLoading: accountCardIsLoading } =
    useGetAccountCard(id as string);
  const { mutate: createSessionContext, isLoading: sessionContextIsLoading } =
    useCreateSessionContext();
  const [sessionContextId, setSessionContextId] = useState<string | null>(null);

  useEffect(() => {
    if (accountCard) window.location.href = accountCard.vCardUrl;
  }, [accountCard]);

  const handleOnclick = useCallback(async () => {
    setSessionContextId(null);
    if (accountCard && !accountCardIsLoading)
      createSessionContext(
        {
          device: 'MOBILE',
          meta: accountCard,
          key: 'QR_ACCOUNT_CARD_PREVIEW',
        },
        {
          onSuccess: (data) => {
            window.location.href = data?.meta?.appLink;
            setSessionContextId(data?._id);
          },
        },
      );
  }, [accountCard, accountCardIsLoading, createSessionContext]);

  if (accountCardIsLoading) return null;

  return (
    <div
      className={cn(
        'card',
        'rounded-md',
        'overflow-hidden',
        'sm:max-w-[430px]',
        'min-w-[300px]',
        'w-full',
        'sm:h-auto',
        'h-screen',
        'sm:justify-start',
        'p-[23px]',
        'min-h-[300px]',
        'text-[#FFFFFF]',
        'bg-[#f5ffe3]',
        'relative',
      )}
    >
      <p className="text-[8px] text-[#a2a69d] text-center absolute top-2 left-2">
        {[sessionContextId, accountCard?._id]
          .filter((item) => !isEmpty(item))
          .map((item) => item || '')
          .join(' | ')}
      </p>
      <div
        className={cn(
          'flex',
          'flex-col',
          'space-y-10',
          'items-center',
          'justify-center',
        )}
      >
        <img src={leapifyLogo} alt={leapifyLogo} className="w-[222px]" />
        <img src={Group22} alt={Group22} className="w-[337px]" />
        <div className="w-[303px]">
          <h1 className="text-2xl text-[#272e35] font-semibold text-center">
            Want to send your contact back?
          </h1>
          <h2 className="text-sm text-[#272e35] text-center">
            {`Log into your Leapify app to instantly share your digital card with John, and grow your network.`}
          </h2>
        </div>
        <Button
          label="Open Leapify App"
          intent="primary"
          size="md"
          className="w-full"
          onClick={() => handleOnclick()}
          disabled={accountCardIsLoading || sessionContextIsLoading}
        />
      </div>
    </div>
  );
};

export default CardPreview;
